import { RoleRoute } from './Modules/Role/routes/role.route'
import { App } from './app'
import { AuthRoute } from './Modules/Auth/routes/auth.route'
import { permissionRouter } from './Modules/Permission/routes/permission.route'
import { AttachmentRouter } from 'Modules/Attachment/routes/attachment.route'
import { UserManagementRoute } from 'Modules/userManagement/routes/userManagement.route'
import { LabourRouter } from 'Modules/Labour/routes/labour.route'
import { AllocationRequestRouter } from 'Modules/allocationRequest/routes/allocationRequest.route'
import { AvailabilityRouter } from 'Modules/availabilityManagement/routes/availability.route'
import { JobRouter } from 'Modules/jobManagement/routes/job.route'
import { RateRouter } from 'Modules/Rating/routes/rating.route'
import { ChatRouter } from 'Modules/Chat/routes/chat.route'


process.on('uncaughtException', (error) => {
    console.error('Uncaught Exception:', error);
    process.exit(1);
});

process.on('unhandledRejection', (reason, promise) => {
    console.error('Unhandled Rejection at:', promise, 'reason:', reason);
    process.exit(1);
});

const app = new App([
    new AttachmentRouter(),
    new RoleRoute(),
    new AuthRoute(),
    new permissionRouter(),
    new UserManagementRoute(),
    new LabourRouter(),
    new AllocationRequestRouter(),
    new AvailabilityRouter(),
    new JobRouter(),
    new RateRouter(),
    new ChatRouter()

])
app.listen()   